import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { LoggedUserService } from '../../services/common/logged-user.service';
import { RoleNames } from '../../utils/role-names';
import { switchMap, tap } from 'rxjs';

@Component({
    selector: 'app-base',
    template: ''
})
export abstract class BaseComponent implements OnInit {
    userRole: string;
    isEditingEnabled: boolean;
    routeData: Data;

    constructor(private loggedUser: LoggedUserService, private route: ActivatedRoute) {
        this.route.data.pipe(
            tap(data => {
                this.routeData = data;
            }),
            switchMap(() => this.loggedUser.loggedUserRole$)
        ).subscribe(role => {
            this.userRole = role;
            this.isEditingEnabled = this.canUserEdit();
        });
    }

    ngOnInit(): void {}

    private canUserEdit(): boolean {
        let isUserReadOnly = this.routeData.isUserReadOnly;
        if (isUserReadOnly && this.userRole == RoleNames.ERT_USER) {
            return false;
        } else{
            return true;
        }
    }
}